import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type MediaForAnalytics_AudioMedia_Fragment = { __typename?: 'AudioMedia', id: string, mimeType?: string | null };

export type MediaForAnalytics_DocumentMedia_Fragment = { __typename?: 'DocumentMedia', id: string, mimeType?: string | null };

export type MediaForAnalytics_ImageMedia_Fragment = { __typename?: 'ImageMedia', id: string, mimeType?: string | null };

export type MediaForAnalytics_InteractiveLiveMedia_Fragment = { __typename?: 'InteractiveLiveMedia', id: string, mimeType?: string | null };

export type MediaForAnalytics_InteractiveMedia_Fragment = { __typename?: 'InteractiveMedia', id: string, mimeType?: string | null };

export type MediaForAnalytics_ModelMedia_Fragment = { __typename?: 'ModelMedia', id: string, mimeType?: string | null };

export type MediaForAnalytics_UnsupportedMedia_Fragment = { __typename?: 'UnsupportedMedia', id: string, mimeType?: string | null };

export type MediaForAnalytics_VideoMedia_Fragment = { __typename?: 'VideoMedia', id: string, mimeType?: string | null };

export type MediaForAnalyticsFragment = MediaForAnalytics_AudioMedia_Fragment | MediaForAnalytics_DocumentMedia_Fragment | MediaForAnalytics_ImageMedia_Fragment | MediaForAnalytics_InteractiveLiveMedia_Fragment | MediaForAnalytics_InteractiveMedia_Fragment | MediaForAnalytics_ModelMedia_Fragment | MediaForAnalytics_UnsupportedMedia_Fragment | MediaForAnalytics_VideoMedia_Fragment;

export type AssetTypeForAnalytics_AudioAsset_Fragment = { __typename?: 'AudioAsset', name: string, filetype?: string | null, media?: { __typename?: 'AudioMedia', id: string, mimeType?: string | null } | null };

export type AssetTypeForAnalytics_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', name: string, filetype?: string | null, media?: { __typename?: 'DocumentMedia', id: string, mimeType?: string | null } | null };

export type AssetTypeForAnalytics_FileAsset_Fragment = { __typename?: 'FileAsset', name: string, filetype?: string | null };

export type AssetTypeForAnalytics_FolderAsset_Fragment = { __typename?: 'FolderAsset', name: string, filetype?: string | null };

export type AssetTypeForAnalytics_ImageAsset_Fragment = { __typename?: 'ImageAsset', name: string, filetype?: string | null, media?: { __typename?: 'ImageMedia', id: string, mimeType?: string | null } | null };

export type AssetTypeForAnalytics_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', name: string, filetype?: string | null, media?: { __typename?: 'InteractiveMedia', id: string, mimeType?: string | null } | null };

export type AssetTypeForAnalytics_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', name: string, filetype?: string | null };

export type AssetTypeForAnalytics_ModelAsset_Fragment = { __typename?: 'ModelAsset', name: string, filetype?: string | null, media?: { __typename?: 'ModelMedia', id: string, mimeType?: string | null } | null };

export type AssetTypeForAnalytics_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', name: string, filetype?: string | null, media?: { __typename?: 'UnsupportedMedia', id: string, mimeType?: string | null } | null };

export type AssetTypeForAnalytics_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', name: string, filetype?: string | null };

export type AssetTypeForAnalytics_VideoAsset_Fragment = { __typename?: 'VideoAsset', name: string, filetype?: string | null, media?: { __typename?: 'VideoMedia', id: string, mimeType?: string | null } | null };

export type AssetTypeForAnalyticsFragment = AssetTypeForAnalytics_AudioAsset_Fragment | AssetTypeForAnalytics_DocumentAsset_Fragment | AssetTypeForAnalytics_FileAsset_Fragment | AssetTypeForAnalytics_FolderAsset_Fragment | AssetTypeForAnalytics_ImageAsset_Fragment | AssetTypeForAnalytics_InteractiveAsset_Fragment | AssetTypeForAnalytics_InteractiveLiveAsset_Fragment | AssetTypeForAnalytics_ModelAsset_Fragment | AssetTypeForAnalytics_UnsupportedAsset_Fragment | AssetTypeForAnalytics_VersionStackAsset_Fragment | AssetTypeForAnalytics_VideoAsset_Fragment;

export const MediaForAnalytics = /*#__PURE__*/ gql`
    fragment MediaForAnalytics on Media {
  id
  mimeType
}
    ` as unknown as DocumentNode<MediaForAnalyticsFragment, unknown>;
export const AssetTypeForAnalytics = /*#__PURE__*/ gql`
    fragment AssetTypeForAnalytics on Asset {
  name
  filetype
  ... on AudioAsset {
    media {
      ...MediaForAnalytics
    }
  }
  ... on DocumentAsset {
    media {
      ...MediaForAnalytics
    }
  }
  ... on ImageAsset {
    media {
      ...MediaForAnalytics
    }
  }
  ... on InteractiveAsset {
    media {
      ...MediaForAnalytics
    }
  }
  ... on UnsupportedAsset {
    media {
      ...MediaForAnalytics
    }
  }
  ... on VideoAsset {
    media {
      ...MediaForAnalytics
    }
  }
  ... on ModelAsset {
    media {
      ...MediaForAnalytics
    }
  }
}
    ${MediaForAnalytics}` as unknown as DocumentNode<AssetTypeForAnalyticsFragment, unknown>;

        

        
export const useMediaForAnalyticsFragment = (
  input: string | Omit<UseFragmentOptions<MediaForAnalyticsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Media' } };
    return input;
  })();

  return useFragment<MediaForAnalyticsFragment>({
    fragment: MediaForAnalytics,
    fragmentName: 'MediaForAnalytics',
    ...options,
  });
};
  
        
        

        
export const useAssetTypeForAnalyticsFragment = (
  input: string | Omit<UseFragmentOptions<AssetTypeForAnalyticsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<AssetTypeForAnalyticsFragment>({
    fragment: AssetTypeForAnalytics,
    fragmentName: 'AssetTypeForAnalytics',
    ...options,
  });
};
  
        